"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MapLoadingOverlay = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _sharedStyles = require("./sharedStyles");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/naming-convention -- prop name format given by external lib */ const Root = (0, _mui.styled)('div')({
    ..._sharedStyles.sharedLoadingStyles,
    pointerEvents: 'none',
    position: 'absolute',
    width: '100%',
    zIndex: 1
});
const MapLoadingOverlay = exports.MapLoadingOverlay = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const testId = getTestId(_models.TestId.DialogLoadingOverlayMap);
    const props = {
        color: 'primary',
        'data-testid': testId
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {
            ...props,
            "aria-label": formatMessage('loading')
        })
    });
});
